import BaseService from './base.service';

export default class RemovalService {
    static ENDPOINT = '/account-removal';

    /**
     * Request account removal. POSTs to the backend, which persists the request
     * and resolves with `{ res: true }` on success or `{ error }` on failure.
     */
    static async requestAccountRemoval(email) {
        return BaseService.post(this.ENDPOINT, { email });
    }
}
